import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { FormError } from '@aeCore/enums/form-error';

function passwordMatchValidator(
  password: string,
  confirmPassword: string,
): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const passwordControl = control.get(password);
    const confirmPasswordControl = control.get(confirmPassword);
    if (!passwordControl || !confirmPasswordControl) {
      return null;
    }

    if (
      passwordControl.value !== confirmPasswordControl.value &&
      (confirmPasswordControl.touched || confirmPasswordControl.dirty)
    ) {
      confirmPasswordControl.setErrors({ [FormError.PASSWORD_MISMATCH]: true });
    }

    return null;
  };
}

function passwordValidator(): ValidatorFn {
  const PASSWORD_REGEXP =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&.])[A-Za-z\d@$!%*?&.]{8,64}$/;

  return (control: AbstractControl): { [key: string]: unknown } | null => {
    const password = control.value;
    const valid = PASSWORD_REGEXP.test(password);

    return valid ? null : { [FormError.INVALID_PASSWORD]: true };
  };
}

export function emailValidator(): ValidatorFn {
  const EMAIL_REGEXP = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return (control: AbstractControl): { [key: string]: unknown } | null => {
    const email = control.value;
    return EMAIL_REGEXP.test(email)
      ? null
      : { [FormError.INVALID_EMAIL]: true };
  };
}

export const CustomValidators = {
  passwordMatchValidator,
  password: () => passwordValidator(),
};

export function phoneNumberValidator(): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    const value = control.value;
    if (!value) {
      return null;
    }

    const regex = /^\+?[1-9]\d{1,14}$/; // E.164 format
    const valid = regex.test(value);
    return valid ? null : { invalidPhone: true };
  };
}

const AT_LEAST_ONE_REQUIRED = 'atLeastOneRequired';

export function atLeastOnePermissionSelectedValidator(
  control: AbstractControl,
): ValidationErrors | null {
  return control.value.length ? null : { [AT_LEAST_ONE_REQUIRED]: true };
}

export function dailyLessThanMonthlyValidator(group: AbstractControl): ValidationErrors | null {
  const daily = group.get('daily')?.value;
  const monthly = group.get('monthly')?.value;

  // Only validate if both fields have values
  if (daily !== null && monthly !== null && daily >= monthly) {
    return { DAILY_EXCEEDS_MONTHLY: true };
  }
  return null;
}

export const urlRegexp = /^(https?:\/\/)?([\w-]+\.)+[a-z]{2,6}(:\d+)?(\/\S*)?$/
